'use strict';

module.exports = function (template, args) {
  if (!args) {
    return interpolate.bind(null, template);
  }

  return interpolate(template, args);
};

function interpolate(template, args) {
  if (typeof args === 'undefined') {
    args = {};
  }
  return template.replace(/{([^}]*)}/g, function (match, key) {
    return key in args ? args[key] : match;
  });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/string-format-obj/index.js
// module id = Jkp1
// module chunks = 0